import { render } from "./DirectDialSelect.vue?vue&type=template&id=6eac047c"
import script from "./DirectDialSelect.vue?vue&type=script&lang=js"
export * from "./DirectDialSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__